(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dolce-product-10x5-vip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.d48-product');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const mainImage = root.querySelector('.d48-main-image');
      const thumbs = root.querySelectorAll('[data-d48-thumb]');
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          thumbs.forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
          if (mainImage) {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = thumb.dataset.imageSrc;
            mainImage.alt = thumb.dataset.imageAlt || 'Minibarquillos Dolcebarquillo';
          }
        });
      });
      const mainAdd = root.querySelector('[id^="d48-main-add-"]');
      const stickyAdd = root.querySelector('[data-d48-sticky-add]');
      const finalAdd = root.querySelector('[data-d48-final-add]');
      if (mainAdd && stickyAdd) stickyAdd.addEventListener('click', () => mainAdd.click());
      if (mainAdd && finalAdd) finalAdd.addEventListener('click', () => mainAdd.click());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dolce-product-120"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.body.classList.add('d120-exact-page');
    document.querySelectorAll('.d120-exact').forEach((root) => {
      const submit = root.querySelector('.d120-exact__native-submit');
      root.querySelectorAll('[data-d120-add]').forEach((cta) => {
        cta.addEventListener('click', (event) => {
          event.preventDefault();
          if (submit && !submit.disabled) submit.click();
        });
      });
    });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.querySelector('.d120-exact')) document.body.classList.remove('d120-exact-page');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dolce-product-48-star"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-lp48]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const main=root.querySelector('[data-pack-submit]');const sticky=root.querySelector('[data-lp48-sticky]');if(sticky&&main&&window.matchMedia('(min-width:800px)').matches){const observer=new IntersectionObserver(([entry])=>sticky.classList.toggle('is-visible',!entry.isIntersecting),{threshold:.15});observer.observe(main)}})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dolce-product-48-vip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.d48-product');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const mainImage = root.querySelector('.d48-main-image');
      const thumbs = root.querySelectorAll('[data-d48-thumb]');
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          thumbs.forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
          if (mainImage) {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = thumb.dataset.imageSrc;
            mainImage.alt = thumb.dataset.imageAlt || 'Minibarquillos Dolcebarquillo';
          }
        });
      });
      const mainAdd = root.querySelector('[id^="d48-main-add-"]');
      const stickyAdd = root.querySelector('[data-d48-sticky-add]');
      const finalAdd = root.querySelector('[data-d48-final-add]');
      if (mainAdd && stickyAdd) stickyAdd.addEventListener('click', () => mainAdd.click());
      if (mainAdd && finalAdd) finalAdd.addEventListener('click', () => mainAdd.click());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dolcebarquillo-mayoristas"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-dbb-form]').forEach((form) => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const message = [
        'Hola Dolcebarquillo, tengo un negocio establecido y quiero solicitar una muestra comercial gratis.',
        '',
        'Nombre: ' + data.get('nombre'),
        'Negocio: ' + data.get('negocio'),
        'Ciudad/comuna: ' + data.get('comuna'),
        'Tipo de negocio: ' + data.get('tipo')
      ].join('\n');
      if (typeof fbq === 'function') fbq('track', 'Lead');
      const number = form.dataset.whatsapp || '56987542002';
      window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(message), '_blank', 'noopener,noreferrer');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
